<template>
  <div>
    <slider />
    <main class="main container  pt-1 p-sm-5">
      <SpecialCategoriesSlide />
      <AmazingProduct />
      <Banners :banners="banners[0]"></Banners>
      <RecommendedProduct></RecommendedProduct>
      <Flashes
        v-if="
          $store.getters['front/getHomeData'] != null &&
          $store.getters['front/getHomeData'].flashes != ''
        "
        :flashes="$store.getters['front/getHomeData'].flashes"
      />
      <Banners :banners="banners[1]"></Banners>
      <Weblogs></Weblogs>
    </main>
  </div>
</template>

<script>
import slider from "@/parts/Front/components/shared/Header";
import RecommendedProduct from "@/parts/Front/components/RecommendedProduct";
import Banners from "@/parts/Front/components/Banners";
import Flashes from "@/parts/Front/components/FlashProducts";
import Weblogs from "@/parts/Front/components/Weblogs";
import debounce from "lodash/debounce";
import SpecialCategoriesSlide from "../components/shared/specialCategoriesSlide.vue";
import AmazingProduct from "../components/shared/AmazingProduct.vue";
export default {
  name: "Home",
  components: {
    slider,
    RecommendedProduct,
    Banners,
    Flashes,
    Weblogs,
    SpecialCategoriesSlide,
    AmazingProduct
  },
  data() {
    return {
      showInstagram: true,
      reRenderInstagramFunction: debounce(this.reRenderInstagram, 250),
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.reRenderInstagramFunction);
  },
  mounted() {
    window.removeEventListener("resize", this.reRenderInstagramFunction);
    window.addEventListener("resize", this.reRenderInstagramFunction);
  },
  methods: {
    reRenderInstagram() {
      this.showInstagram = false;
      this.$nextTick(() => {
        this.showInstagram = true;
      });
    },
  },
  computed: {
    banners() {
      if (this.$store.getters["front/getHomeData"] != null) {
        let advertise = this.$store.getters["front/getHomeData"].advertise;
        return [
          [advertise.banner_1, advertise.banner_2],
          [advertise.banner_3, advertise.banner_4],
        ];
      } else {
        return [
          [null, null],
          [null, null],
        ];
      }
    },
  },
};
</script>
